var utils = require('./helper/utils');
var es = require('./helper/es');
var tcss = require('./api.tcss');
var Performance = require('./plugin/performance');

var
  // url = '//utherapitest.browser.qq.com/qbweb/report',
  url = '//utherapi.browser.qq.com/qbweb/report',
  win = window,
  doc = document,
  ext = win.external,
  encode = win.encodeURIComponent;

var default_conf = {
  protocol : 8888,
  key      : 0,
  v1       : 0,
  v2       : 0,
  v3       : 0,
  s1       : '',
  s2       : '',
  s3       : '',
  // ---------------------------------------------------------------------------
  // 产品名称，默认为当前域名
  pname    : location.hostname,
  // 当为 true 时，v 和 s 的默认设定分别都为 0 和空字符串
  isCustom : false,
  tcss     : false,
  // 默认自动发送 pv
  autopv   : true,
  // 默认自动页面性能上报
  autoPerformance: true
};

function WSD (conf) {
  if (!(this instanceof WSD)) return new WSD(conf);
  this.setting(conf);
  this._initS2Obj();

  if (this.conf.autopv && !this.conf.isCustom) {
    this.pv();
  }
}

WSD.default_conf = default_conf;

WSD.prototype = {

  setting: function (conf) {
    if (!this.conf) this.conf = default_conf;
    this.conf = es.extend({}, this.conf, conf);
  },

  pv: function (pname) {
    this.track({v2: 1, s1: utils.getGuid(), s3: pname || this.conf.pname});
    if (this.conf.tcss) tcss.pv();
  },

  // key 值形式参考点击流： a.b.c.d
  click: function (key) {
    this.track({v2: 2, s1: utils.getGuid(), s3: key || ''});
    if (this.conf.tcss) tcss.click(key);
  },

  performance: function (pname) {
    if (!win.performance) return;
    // 性能相关的 key 取值范围 [1000, 1099]
    // 1001 为 performance.timing 相关的监控
    var self = this;
    utils.onLoadEventEnd(function () {
      self.track({key:1001, v2: 3,
        s1: es.stringify(Performance()), s3: pname || self.conf.pname});
    });
  },

  // First Screen
  fs: function (time, pname) {
    this.track({key:1002, v2: 4, v1: time, s3: pname || this.conf.pname});
  },

  track: function (opts, fn1, fn2) {

    var self = this, conf = self.conf,
      o = es.extend({}, conf, opts);

    // 尘归尘土归土，该 number or string 的一个都不能错，key 也得必须指定
    if (!es.inum(o.protocol, o.key, o.v1, o.v2, o.v3)
      || !es.istr(o.s1, o.s2, o.s3) || o.key <= 0) {
      return es.isFunction(fn2) && fn2(o);
    }

    if (!o.isCustom && o.protocol === 8888) {
      // v3 用于区分 QB or not QB
      // 为什么是数字 96，因为外形上看起来像小写的 qb
      // 为什么是 69，因为 96 反过来或倒过来就是 69 啊
      o.v3 = utils.isQB ? 96 : 69;
      // s2 默认值
      if (!o.s2) o.s2 = es.stringify(self.s2obj)
    }

    if (utils.isQB && ext && ext.dataReport) {
      try {
        // 第三个参数为上报类型： 0-实时，1-退出累计，2-退出非累计
        ext.dataReport(o.protocol, o.key, 0, o.v1, o.v2, o.v3, o.s1, o.s2, o.s3);
        es.isFunction(fn1) && fn1(o)
      } catch (e) {
        win.console && console.error(e);
        es.isFunction(fn2) && fn2(o);
        // todo 是否应该尝试下 _notQBTrack ?
      }
    } else {
      encodeS123(o);
      self._notQBTrack(o, fn1, fn2);
    }
  },

  _notQBTrack: function (conf, fn1, fn2) {
    var str = [
      '_ApplicationId=qbweb',
      'stComm=' + es.stringify({sGuid: utils.getGuid()}),
      'vProtocols_Function=' + es.stringify([{
         iProtocol : conf.protocol,
         iKey      : conf.key,
         iValueI   : conf.v1,
         iValueII  : conf.v2,
         iValueIII : conf.v3,
         sValueI   : conf.s1,
         sValueII  : conf.s2,
         sValueIII : conf.s3
      }])
    ].join('&');

    utils.imgsend(url + '?' + str, function () {
      es.isFunction(fn1) && fn1(o);
    }, function () {
      es.isFunction(fn2) && fn2(o);
    });
  },

  _initS2Obj : function () {
    this.s2obj = {
      'name' : this.conf.pname,
      'id'   : utils.getGuid(),
      'ua'   : navigator.userAgent,
      'url'  : location.href,
      'ref'  : doc.referrer,
      't'    : (new Date).getTime(),
      'w'    : screen.width,
      'h'    : screen.height,
      'vw'   : win.innerWidth || doc.documentElement.clientWidth || 0,
      'vh'   : win.innerHeight || doc.documentElement.clientHeight || 0,
      'dpr'  : win.devicePixelRatio || 1,
      'tag'  : utils.getUrlParams('ADTAG') || ''
    };
  }
};

function encodeS123 (obj) {
  obj.s1 = encode(obj.s1);
  obj.s2 = encode(obj.s2);
  obj.s3 = encode(obj.s3);
  return obj
}

module.exports = WSD;



//////////////////
// WEBPACK FOOTER
// ./src/api.wsd.js
// module id = 9
// module chunks = 0